module.exports = __webpack_public_path__ + "static/media/matchatea.7e4939f2.jpg";